export default [
  {
    path: '/home',
    name: 'home',
    component: () => import('@/views/dashboard/home/Home.vue'),
    meta: {
		resource: 'Auth',
    },
  },
  {
    path: '/boxea',
    name: 'boxea',
    component: () => import('@/views/dashboard/boxea/tb.vue'),
    meta: {
		resource: 'Auth',
    },
  },
  {
    path: '/izibox',
    name: 'izibox',
    component: () => import('@/views/dashboard/izibox/tb.vue'),
    meta: {
		resource: 'Auth',
    },
  },
  {
    path: '/izibox2',
    name: 'izibox2',
    component: () => import('@/views/dashboard/izibox2/tb.vue'),
    meta: {
		resource: 'Auth',
    },
  },
  {
    path: '/domicializ',
    name: 'domicializ',
    component: () => import('@/views/dashboard/domicializ/tb.vue'),
    meta: {
		resource: 'Auth',
    },
  },
  {
    path: '/resa/:id',
    name: 'resa',
    component: () => import('@/views/resa/resa.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/resa2/:id',
    name: 'resa2',
    component: () => import('@/views/resa/resa2.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/dom/:id',
    name: 'dom',
    component: () => import('@/views/resa/dom.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/dom2/:id',
    name: 'dom2',
    component: () => import('@/views/resa/dom.vue'),
    meta: {
      layout: 'full',
      resource: 'Auth',
      action: 'read',
    },
  },
  {
    path: '/admin-dom/login',
    name: 'admin-dom-login',
    component: () => import('@/views/admindom/Login.vue'),
    meta: {
      layout: 'full',
      requiresDomAdminGuest: true,
    },
  },
  {
    path: '/admin-dom/forgot-password',
    name: 'admin-dom-forgot-password',
    component: () => import('@/views/admindom/ForgotPassword.vue'),
    meta: {
      layout: 'full',
      requiresDomAdminGuest: true,
    },
  },
  {
    path: '/admin-dom/reset-password/:token',
    name: 'admin-dom-reset-password',
    component: () => import('@/views/admindom/ResetPassword.vue'),
    meta: {
      layout: 'full',
      requiresDomAdminGuest: true,
    },
  },
  {
    path: '/admin-dom/dossiers',
    name: 'admin-dom-dossiers',
    component: () => import('@/views/admindom/Dossiers.vue'),
    meta: {
      layout: 'full',
      requiresDomAdmin: true,
    },
  },
  {
    path: '/admin-dom/dossiers/:UIdemande',
    name: 'admin-dom-dossier-detail',
    component: () => import('@/views/admindom/DossierDetail.vue'),
    meta: {
      layout: 'full',
      requiresDomAdmin: true,
    },
  },
  {
    path: '/admin-dom/profil',
    name: 'admin-dom-profil',
    component: () => import('@/views/admindom/Profil.vue'),
    meta: {
      layout: 'full',
      requiresDomAdmin: true,
    },
  },
  {
    path: '/admin-dom/documentation',
    name: 'admin-dom-documentation',
    component: () => import('@/views/admindom/Documentation.vue'),
    meta: {
      layout: 'full',
      requiresDomAdmin: true,
    },
  },
  {
    path: '/admin-dom/utilisateurs',
    name: 'admin-dom-utilisateurs',
    component: () => import('@/views/admindom/Utilisateurs.vue'),
    meta: {
      layout: 'full',
      requiresDomAdmin: true,
      requiresDomSuperAdmin: true,
    },
  },
  {
    path: '/admin-dom/formules',
    name: 'admin-dom-formules',
    component: () => import('@/views/admindom/Formules.vue'),
    meta: {
      layout: 'full',
      requiresDomAdmin: true,
      requiresDomSuperAdmin: true,
    },
  },
  {
    path: '/admin-dom/templates',
    name: 'admin-dom-templates',
    component: () => import('@/views/admindom/Templates.vue'),
    meta: {
      layout: 'full',
      requiresDomAdmin: true,
      requiresDomSuperAdmin: true,
    },
  },
  {
    path: '/admin-dom/documents-requis',
    name: 'admin-dom-documents-requis',
    component: () => import('@/views/admindom/DocumentsRequis.vue'),
    meta: {
      layout: 'full',
      requiresDomAdmin: true,
      requiresDomSuperAdmin: true,
    },
  },
  {
    path: '/admin-dom/formes-juridiques',
    name: 'admin-dom-formes-juridiques',
    component: () => import('@/views/admindom/FormesJuridiques.vue'),
    meta: {
      layout: 'full',
      requiresDomAdmin: true,
      requiresDomSuperAdmin: true,
    },
  },
]
